const SET_WIDTH = 'SET_WIDTH';

// Init
const initialState = {
  isMobile: false,
  width: window.innerWidth,
};

// Reducer
const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WIDTH:
      return {
        ...state,
        width: action.payload.width,
        isMobile: action.payload.width <= 600,
      };
    default:
      return state;
  }
};

// Actions
export const SET_WIDTH_ACTION = width => ({
  type: SET_WIDTH,
  payload: { width },
});

export default deviceReducer;
